import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ForgotPasswordService {
	private decryptTokenUrl: string = environment.baseApiUrl + 'tool/decryptToken/{token}';

	constructor(private http: HttpClient) {}

	submitDecryptToken(token: string, key: string): Observable<JSON> {
		const submitDecryptTokenUrl = this.decryptTokenUrl.replace('{token}', token);
		const body = { key: key };
		return this.http.post<JSON>(submitDecryptTokenUrl, body);
	}
}
